// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"0d16431f","344":"36f87596","422":"32b2ec93","439":"54989d25","632":"1cd225e1"}[chunkId] + ".chunk.js";
};